module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/impression_icon02-eb1c018c793c7a8e151a0c1cc3cb0a4f.png";